import React from "react";
import { AppContext, User } from "../../../../context/appContext";
import axios from "axios";
import { useSnackbar } from "notistack";
import IDashboardData from "../interface/iDashboardData";

export const DashboardContext = React.createContext<any>({});

const DashboardProvider = ({ children }: any): React.JSX.Element => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const [dashboardData, setDashboardData] =
    React.useState<IDashboardData | null>(null);
  const fetchedData = React.useRef<boolean>(false);

  const fetchDashboardData = React.useCallback((): void => {
    axios
      .post(
        "https://bewerbungscoaching.wbstraining.de/api/service/admin/getDashboardData.php",
        {
          sessionId: user.sessionId,
        },
      )
      .then((response) => {
        checkSession(response);
        setDashboardData(response.data);
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar("Fehler beim Abrufen der Dashboard-Daten", {
          variant: "error",
        });
      });
  }, [checkSession, enqueueSnackbar, user.sessionId]);

  React.useEffect(() => {
    if (fetchedData.current) return;
    fetchedData.current = true;
    fetchDashboardData();
  }, [fetchDashboardData]);

  const value: {} = React.useMemo(
    () => ({
      dashboardData,
      fetchedData,
    }),
    [dashboardData],
  );

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;
